<template>
  <div class="info">
    <p class="header">
      <router-link :to="'/profile'" v-if="$route.name === 'profile'">
        <span class="link"> Профиль<i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>
      <router-link
        :to="'/all-users'"
        v-if="userRole != 'leader' && userRole != 'leader_admin' && $route.name != 'profile'"
      >
        <span class="link"> Все пользователи <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>
      <router-link
        :to="'/users'"
        v-if="(userRole === 'leader' || userRole === 'leader_admin') && $route.name != 'profile'"
      >
        <span class="link"> Все пользователи <i style="font-size: 10px;" class="icon-button-arrow"></i> </span>
      </router-link>

      {{ profileInfo.surname }} {{ profileInfo.name }}
    </p>
    <div class="profile_info">
      <div
        class="profile_avatar"
        :style="{
          backgroundImage: profileInfo.image ? `url(${config.baseUrl + profileInfo.image})` : ''
        }"
      ></div>
      <div class="profile_text">
        <ul>
          <li class="user-name">
            <span class="right-info"
              >{{ profileInfo.surname }} {{ profileInfo.name }} {{ profileInfo.patronymic }}</span
            >
          </li>
          <li>
            <span class="left-info">Роль:</span>
            <span class="right-info">{{ roleName }}</span>
          </li>
          <li>
            <span class="left-info">Должность:</span>
            <span class="right-info">{{ profileInfo.position }}</span>
          </li>
          <li>
            <span class="left-info">Логин:</span>
            <span class="right-info">{{ profileInfo.email }}</span>
          </li>
          <li v-if="userRole === 'leader' || userRole === 'leader_admin'">
            <span class="left-info">Филиал:</span>
            <span class="right-info">{{ currentUser.branch.name }}</span>
          </li>
          <li v-else>
            <span class="left-info">Филиал:</span>
            <span class="right-info">{{ profileInfo.branch.name }}</span>
          </li>
        </ul>
      </div>
      <div class="profile-actions">
        <ul>
          <li v-if="($route.name === 'profile' || userRole != 'leader') &&  userRole !== 'user'">
            <button class="profile-edit" @click="$emit('edit', profileInfo)">
              <i class="mdi mdi-account-edit"></i> Редактировать профиль
            </button>
          </li>
          <li v-if="$route.name != 'profile' && userRole != 'leader'">
            <button class="profile-edit" @click="$emit('delete')">
              <i class="mdi mdi-account-remove-outline"></i> В архив
            </button>
          </li>
        <li v-if="($route.name === 'profile' || userRole != 'leader')  && userRole !== 'user'">
            <button class="profile-edit" @click="$emit('photo')">
              <i class="mdi mdi-shape-circle-plus"></i> Заменить фото
            </button>
          </li>
          <li v-if="$route.name != 'profile' && roleName === 'Студент' && userRole != 'leader_admin'">
            <button class="profile-edit" @click="$emit('open-modal')">
              <i class="mdi mdi-file-document-box-plus-outline"></i> Добавить курс(-ы) студенту
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from '@/config'

export default {
  props: {
    profileInfo: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    config() {
      return config
    },
    roleName() {
      const { roles } = this.profileInfo;
      if (!roles.length) return '-';
      return this.$dictionary(this.profileInfo.roles[0].name)
    },
    userRole() {
      return this.$store.state.auth.role[0]
    },
    currentUser() {
      return this.$store.state.auth.currentUser
    }
  }
}
</script>
